import React, { useContext, useEffect, useState, useRef } from "react";
import { useTranslation } from 'react-i18next';
import { BreadcrumbContext } from '../../../../components/Breadcrumb';
import { AuthContext } from "../../../../components/FirebaseAuth";
import { CloudFunctions } from "../../../../components/FirebaseAuth/firebase";
import Loader from "../../../../components/Loader";
import DataTable from "../../../../components/DataTable";
import { useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import { Button, Box, Alert, Avatar } from "@mui/material";

const UserList = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { userData } = useContext(AuthContext);
    const mountedRef = useRef(true);
    const { setBreadcrumb } = useContext(BreadcrumbContext);
    const [users, setUsers] = useState(null);
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    useEffect(() => {
        setBreadcrumb(
            [
                {
                    to: "/",
                    text: t('common.home'),
                    active: false
                },
                {
                    to: "/account/"+userData.currentAccount.id+"/",
                    text: userData.currentAccount.name,
                    active: false
                },
                {
                    to: null,
                    text: t('users.title'),
                    active: true
                }
            ]);
        setError(null);
        const getAccountUsers = CloudFunctions.httpsCallable('getAccountUsers');
        getAccountUsers({
            accountId: userData.currentAccount.id
        }).then(res => {
            if (!mountedRef.current) return null
            let totalCounter = 0;
            res.data.forEach(record => {
                record.nameCol = <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                }}><Avatar alt={record.displayName} src={record.photoUrl} /><strong style={{marginLeft: '15px'}}>{record.displayName}</strong></div>
                record.roleCol = record.id===userData.currentAccount.owner?t('users.roleOwner'):(record.role.charAt(0).toUpperCase()+record.role.slice(1));
                record.lastLoginTimeCol = (new Date(record.lastLoginTime)).toLocaleString();
                if(record.id !== userData.currentAccount.owner){
                    record.actionCol = <Button size="small" variant="contained" onClick={() => navigate("/account/"+userData.currentAccount.id+"/users/change/"+record.id)}>{t('users.changeRole')}</Button>
                }
                totalCounter++;
            });
            setTotal(totalCounter);
            setData(res.data);
        }).catch(err => {
            if (!mountedRef.current) return null
            setError(err.message);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[userData, setBreadcrumb, navigate, t]);

    useEffect(() => {
        const startIndex = page * pageSize;
        let records = [];
        for(let i=startIndex; i<data.length; i++){
            if(i>=startIndex+pageSize){
                break;
            }
            records.push(data[i]);
        }
        if(records.length > 0){
            setUsers(records);
        }
        window.scrollTo(0, 0);
    },[page, pageSize, data])

    useEffect(() => {
        return () => {
            mountedRef.current = false
        }
    },[]);

    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
                <Button onClick={() => navigate("/account/"+userData.currentAccount.id+"/users/add")} color="primary" variant="contained" startIcon={<AddIcon />}>
                    {t('users.addUser')}
                </Button>
            </Box>
            {error !== null &&
                <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
            }
            {users === null ? (
                <Loader text={t('users.loadingUsers')} />
            ):(
                <DataTable columns={[
                    {name: t('users.colName'), field: "nameCol", style: {width: '40%'}},
                    {name: t('users.colRole'), field: "roleCol", style: {width: '20%'}},
                    {name: t('users.colLastLogin'), field: "lastLoginTimeCol", style: {width: '30%'}},
                    {name: t('users.colAction'), field: "actionCol", style: {width: '10%'}}
                ]}
                rows={users}
                totalRows={total}
                pageSize={pageSize}
                page={page}
                handlePageChane={(e, p) => {
                    setPage(p);
                }}
                handlePageSizeChange={(e) => {
                    setPage(0);
                    setPageSize(e.target.value);
                }}
                ></DataTable>
            )}
        </>

    )
}

export default UserList;
